import React from 'react';

const backgroundColors = ['#EFDBFF', '#B5F5EC', '#FFD6E7', '#D9F7BE'];
const colors = ['#531DAB', '#08979C', '#C41D7F', '#389E0D'];

const AvatarAddressBook = ({ name, index, width, height }) => {
  const getInitials = (name) => {
    const nameParts = name.split(' ');
    const initials = nameParts.map(part => part[0]).join('');
    return initials.substring(0, 2).toUpperCase();
  };

  const backgroundColor = backgroundColors[index % backgroundColors.length];
  const color = colors[index % colors.length]

  const avatarStyle = {
    backgroundColor,
    color,
    width,
    height,
    borderRadius: '50%',
    display: 'flex',
    marginRight: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '12px',
    fontWeight: '500',
    textTransform: 'uppercase',
  };

  return <div style={avatarStyle}>{getInitials(name)}</div>;
};

export default AvatarAddressBook;